import { Icon, Spinner, IconButton, IIconNames } from '@hai/ui-react';
import React from 'react';

interface Busy {
  busy?: boolean;
  /** <IconButton> vs <Icon> */
  iconButton?: boolean;
  color?: string;
  disabled?: boolean;
  isActive: boolean;
  activeIcon: IIconNames;
  inactiveIcon: IIconNames;
  tooltip?: string;
  onClick?: (ev: any) => void;
}

const BusyIcon: React.FunctionComponent<Busy> = ({
  busy = false,
  iconButton,
  color,
  disabled,
  isActive,
  activeIcon,
  inactiveIcon,
  tooltip,
  onClick,
}: Busy) => {
  return busy ? (
    <Spinner loopTime={1} {...{ style: { width: '18px', height: '18px', margin: '0px 3px 0px 3px' } }} />
  ) : iconButton ? (
    <IconButton disabled={disabled} onClick={onClick} title={tooltip}>
      <Icon iconname={isActive ? activeIcon : inactiveIcon} color={color} />
    </IconButton>
  ) : (
    <Icon
      iconname={isActive ? activeIcon : inactiveIcon}
      color={color}
      //FIXME disabled={disabled}
      onClick={onClick}
      title={tooltip}
    />
  );
};

export default BusyIcon;
